export default "__VITE_ASSET__CiFcE3Cy__"